import { GcdPage } from '@auteco/pages'
import React from 'react'

const GdcContainer = () => {
  const reloadInfo = () => {}

  return <GcdPage />
}

export { GdcContainer }
